import type { IconNode } from '../types';

/**
 * @name skis
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMiA0IDMtMSIgLz4KICA8cGF0aCBkPSJtMyAyIDcgMjAiIC8+CiAgPHBhdGggZD0iTTEwIDIgMyAyMiIgLz4KICA8cGF0aCBkPSJtMiAyMCAzIDEiIC8+CiAgPHBhdGggZD0iTTIyIDIyVjZjMC0yLjItMi00LTItNHMtMiAxLjgtMiA0YzAtMi4yLTItNC0yLTRzLTIgMS44LTIgNHYxNloiIC8+CiAgPHBhdGggZD0iTTE4IDZ2MTYiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/skis
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const skis: IconNode = [
  ['path', { d: 'm2 4 3-1', key: 'xqn5we' }],
  ['path', { d: 'm3 2 7 20', key: 'd5po3n' }],
  ['path', { d: 'M10 2 3 22', key: '13bmm1' }],
  ['path', { d: 'm2 20 3 1', key: '10lztc' }],
  ['path', { d: 'M22 22V6c0-2.2-2-4-2-4s-2 1.8-2 4c0-2.2-2-4-2-4s-2 1.8-2 4v16Z', key: 'e400m4' }],
  ['path', { d: 'M18 6v16', key: '33nz89' }],
];

export default skis;
